// extracted by mini-css-extract-plugin
export var articleBanner = "article-banner-module--article-banner--f4FD+";
export var iconLink = "article-banner-module--icon-link--fumwt";
export var facebook = "article-banner-module--facebook--3Zzut";
export var instagram = "article-banner-module--instagram--viTQk";
export var linkedin = "article-banner-module--linkedin--E0MTu";
export var youtube = "article-banner-module--youtube--ZOzcQ";
export var twitter = "article-banner-module--twitter--kfyn2";
export var pinterest = "article-banner-module--pinterest--lIVTJ";